import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 175px;
  aspect-ratio: 1;
  padding: 45px;
  border-radius: 50%;
  background-color: var(--color-numa-pink--100);
  align-self: center;

  > * {
    flex: 1 0 auto;
  }
`;
